var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotificationBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M5.514 16l1.18-1.182c.378-.378.586-.88.586-1.414V8.727c0-1.357.59-2.654 1.62-3.556 1.038-.91 2.36-1.31 3.737-1.129 2.327.309 4.082 2.413 4.082 4.895v4.467c0 .534.208 1.036.585 1.413L18.485 16H5.515zM14 18.341C14 19.24 13.083 20 12 20s-2-.76-2-1.659V18h4v.341zm6.521-3.133l-1.8-1.804V8.937c0-3.481-2.503-6.438-5.82-6.877-1.923-.256-3.863.331-5.318 1.607C6.118 4.949 5.28 6.793 5.28 8.727v4.677l-1.802 1.804c-.469.47-.608 1.169-.354 1.782.255.614.848 1.01 1.512 1.01H8v.341C8 20.359 9.793 22 12 22s4-1.641 4-3.659V18h3.363c.664 0 1.256-.396 1.51-1.009.255-.614.117-1.314-.352-1.783z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotificationBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification_bell.e4ab4822.svg";
export { ForwardRef as ReactComponent };